import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import axios from 'axios';
import is from '@sindresorhus/is';

var validatePayload = function validatePayload(payload) {
  if (!payload) {
    throw new Error('Action with type HTTP_* was dispatched without a payload!');
  }

  var onSuccess = payload.onSuccess,
      onFailure = payload.onFailure,
      options = payload.options;

  if (!onSuccess || !onFailure) {
    throw new Error('Action with type HTTP_* was dispatched without an onSuccess and onFailure value in the payload!');
  }

  if (!is.function(onSuccess) || !is.function(onFailure)) {
    throw new Error('Action with type HTTP_* was dispatched without invalid onSuccess and onFailure values, they must be functions that return an action!');
  }

  if (!options) {
    throw new Error('Action with type HTTP_* was dispatched without options in the payload!');
  } // method and url are the only 2 required keys


  if (!options.url) {
    throw new Error('Action with type HTTP_* was dispatched without a url set in the options!');
  }

  if (!options.method) {
    throw new Error('Action with type HTTP_* was dispatched without a url set in the options!');
  }
};
/**
 * Redux middleware that can make http requests using axios for actions that meet a certain criteria.
 *
 * For an action to trigger a request, it must have:
 *
 * - A type that starts with `HTTP_`
 * - A `payload` object with `onSuccess`, `onFailure`, and `options` set:
 *     - `onSuccess` is a function that's called when a request is successful. It's passed the axios response object when called.
 *     - `onFailure` is a function that's called when a request fails. It's passed the axios error object when called.
 *     - `options` is an [axios request config](https://github.com/axios/axios#request-config)
 *
 * ```js
 * import { createStore } from 'redux';
 * import thunk from 'redux-thunk';
 * import { httpMiddleware } from '@minerva-analytics/pantheon';
 *
 *
 * const store = createStore(
 *   yourRootReducer,
 *   yourPreloadedState,
 *   // Make sure you put the thunk middleware first!
 *   applyMiddleware(thunk, httpMiddleware, ...yourOtherMiddleware),
 * );
 * ```
 *
 * Note: The parameters and return values described below are irrelevant for end users as they are provided automatically by redux.
 *
 * @param {Object} store - The redux store
 * @returns {Function} - A function that can handle the next
 */


var httpMiddleware = function httpMiddleware(_ref) {
  var dispatch = _ref.dispatch;
  return function (next) {
    return /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(action) {
        var _action$payload, onSuccess, onFailure, options, response;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                next(action);

                if (action.type.match(/^HTTP_.*/)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                validatePayload(action.payload);
                _action$payload = action.payload, onSuccess = _action$payload.onSuccess, onFailure = _action$payload.onFailure, options = _action$payload.options;
                _context.prev = 5;
                _context.next = 8;
                return axios(options);

              case 8:
                response = _context.sent;
                dispatch(onSuccess(response));
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](5);
                dispatch(onFailure(_context.t0));

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[5, 12]]);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }();
  };
};

export default httpMiddleware;